/* ============ BKS CROSS — configurateur ============

   Le même moteur que la VELTO et le scooter, ramené à ce que la gamme cross
   sait vraiment faire : sept couleurs de simili, pas de matière (ni alcantara,
   ni chrome, ni carbone — on ne les a pas en découpe cross).

   Ce qui change vraiment ici, c'est que LE DÉCOUPAGE fait le prix. Le client
   choisit combien de pièces composent sa selle ; la couleur, elle, est gratuite.

     dessus d'un tenant + côté d'un tenant + bandes  ->  3 pièces ->  69 €
     une des deux zones coupée en deux               ->  4 pièces ->  89 €
     les deux coupées en deux                        ->  5 pièces -> 120 €

   Les cinq bandes grip sont toujours séparables une par une, à n'importe quel
   palier et sans supplément : c'est de la couleur, pas de la découpe en plus.
   C'est exactement ce que le concurrent ne propose pas.

   Le patch BKS n'est pas une zone : il est photographié à l'identique dans les
   sept selles pleines, donc il reste noir quoi qu'on choisisse. Vérifié —
   2 784 pixels rigoureusement invariants dans le calque « dessus-bas ».
   ============================================================ */
(function(){
'use strict';

/* Où chercher les calques. En local : _couleurs/<zone>/<slug>.webp, ouvrable
   par double-clic. push-cross-theme.js réécrit ces quatre lignes pour taper
   dans le CDN Shopify, où tout est à plat : cr-<zone>-<slug>.webp */
var IMG = 'https://cdn.shopify.com/s/files/1/0400/3086/3513/files/cr-';
var SEP = '-';
var VER = '?v=1789203527';
function urlCalque(zone, slug){ return IMG + zone + SEP + slug + '.webp' + VER; }

/* ---------- les sept couleurs ----------
   Relevées sur les calques eux-mêmes, pas choisies à l'écran : la pastille
   montre donc la teinte que le client recevra. Les deux bleus sont deux
   références de marque, pas un clair et un foncé. */
var COULEURS = [
  { slug:'noir',           nom:'Noir',            hex:'#363636' },
  { slug:'rouge',          nom:'Rouge',           hex:'#d74751' },
  { slug:'orange',         nom:'Orange',          hex:'#d78147' },
  { slug:'jaune',          nom:'Jaune',           hex:'#d5d647' },
  { slug:'vert',           nom:'Vert',            hex:'#6dd747' },
  { slug:'bleu-yamaha',    nom:'Bleu Yamaha',     hex:'#464cd8' },
  { slug:'bleu-husqvarna', nom:'Bleu Husqvarna',  hex:'#444186' }
];
function coul(s){ for(var i=0;i<COULEURS.length;i++) if(COULEURS[i].slug === s) return COULEURS[i];
                  return COULEURS[0]; }
function nomCoul(s){ return coul(s).nom; }

/* ---------- marques et gabarits ----------
   Repris de la fiche « Housse de Selle Moto SM Personnalisée » : ce sont les
   patrons que l'atelier possède réellement. L'ordre est celui du catalogue, pas
   un tri alphabétique — « 125cc-450cc » se classerait avant « 85cc ». */
var MARQUES = [
  { cle:'KTM', nom:'KTM', modeles:[
    '125cc-450cc sx(f) 2016/18', '125cc-450cc sx(f) 2019/22', '125cc-450cc sx(f) 2023/27',
    '125cc-450cc exc(f) 2017/19', '125cc-450cc exc(f) 2020/23', '125cc-450cc exc(f) 2024/26',
    '85cc sx 2013/17', '85cc sx 2018/22', '85cc sx 2023/24', '85cc sx 2025' ] },
  { cle:'HUSQVARNA', nom:'Husqvarna', modeles:[
    '125cc-450cc fc/fs/fx/tc/tx 2016/18', '125cc-450cc fc/fs/fx/tc 2019/22',
    '125cc-450cc fc/fs/tc 2023/25', '125cc-501cc fe/te 2017/19',
    '150cc-501cc fe/te/tx 2020/23', '150cc-501cc te/fe 2024/25' ] },
  { cle:'HONDA', nom:'Honda', modeles:[
    '250cc crf 2005/09', '250cc crf 2010/13', '250cc crf 2014/21',
    '450cc crf 2005/08', '450cc crf 2009/12', '450cc crf 2021/26' ] },
  { cle:'YAMAHA', nom:'Yamaha', modeles:[
    '125cc-250cc yz 1992/95', '125cc-250cc yz 1996/01', '125cc-250cc yz 2002/21',
    '250cc-450cc yz-f 2014/18', '450cc yz-f 2010/13', '400cc-426cc wr-f/yz-f 1998/02',
    '250cc-450cc wr-f 2007/14', '125cc-250cc wr-r/wr-x 2008/16', '125cc dt-r/dt-x 1998/06',
    '80cc yz 1996/01', '65cc yz 2018/26', '80cc pw 1983/06', '50cc pw toutes annees' ] },
  { cle:'BETA', nom:'Beta', modeles:[
    '125cc-480cc 2014/19', '450cc rx 2024/26' ] }
];
function marqueDe(cle){ for(var i=0;i<MARQUES.length;i++) if(MARQUES[i].cle === cle) return MARQUES[i];
                        return null; }

/* ---------- rubrique de marque ----------
   Le thème ne transporte pas la collection dans le lien produit : le client
   arrivé par « housse de selle KTM » doit quand même tomber sur ses KTM. On
   lit donc la page d'où il vient. Rien trouvé = les cinq marques. */
var GAMMES = {
  'housse-de-selle-ktm':       'KTM',
  'housse-de-selle-husqvarna': 'HUSQVARNA',
  'housse-de-selle-honda':     'HONDA',
  'housse-de-selle-yamaha':    'YAMAHA',
  'housse-de-selle-beta':      'BETA'
};
function litGamme(){
  try{
    var p = new URLSearchParams(location.search).get('marque');
    if(p && marqueDe(p.toUpperCase())) return p.toUpperCase();
    var m = String(document.referrer || '').match(/\/collections\/([a-z0-9-]+)/i);
    if(m && GAMMES[m[1]]) return GAMMES[m[1]];
  }catch(e){}
  return null;
}

/* ---------- le produit Shopify ----------
   Rempli par creer-cross-configurateur.js : il écrit entre les deux repères,
   pour que la liste des variantes ne soit jamais recopiée à la main. */
/* @@VARIANTES_DEBUT@@ */
/* Écrit par creer-cross-configurateur.js le 2026-09-12 — ne pas modifier à la main. */
var VAR = {
  "125cc-450cc sx(f) 2016/18": 54938272301397,
  "125cc-450cc exc(f) 2017/19": 54938272334165,
  "85cc sx 2013/17": 54938272366933,
  "85cc sx 2018/22": 54938272399701,
  "85cc sx 2023/24": 54938272432469,
  "85cc sx 2025": 54938272465237,
  "250cc crf 2005/09": 54938272498005,
  "250cc crf 2010/13": 54938272530773,
  "250cc crf 2014/21": 54938272563541,
  "450cc crf 2005/08": 54938272596309,
  "450cc crf 2009/12": 54938272629077,
  "125cc-480cc 2014/19": 54938272661845,
  "125cc-450cc fc/fs/tc 2023/25": 54938272694613,
  "150cc-501cc te/fe 2024/25": 54938272727381,
  "125cc-450cc fc/fs/fx/tc 2019/22": 54938272760149,
  "150cc-501cc fe/te/tx 2020/23": 54938272792917,
  "125cc-450cc fc/fs/fx/tc/tx 2016/18": 54938272825685,
  "125cc-501cc fe/te 2017/19": 54938272858453,
  "450cc crf 2021/26": 54938272891221,
  "125cc-450cc sx(f) 2019/22": 54938272923989,
  "125cc-450cc sx(f) 2023/27": 54938272956757,
  "125cc-450cc exc(f) 2020/23": 54938272989525,
  "125cc-450cc exc(f) 2024/26": 54938273022293,
  "450cc rx 2024/26": 54938273055061,
  "450cc yz-f 2010/13": 54938273087829,
  "125cc-250cc yz 2002/21": 54938273120597,
  "250cc-450cc yz-f 2014/18": 54938273153365,
  "125cc-250cc wr-r/wr-x 2008/16": 54938273186133,
  "250cc-450cc wr-f 2007/14": 54938273218901,
  "125cc-250cc yz 1996/01": 54938273251669,
  "125cc-250cc yz 1992/95": 54938273284437,
  "400cc-426cc wr-f/yz-f 1998/02": 54938273317205,
  "80cc yz 1996/01": 54938273349973,
  "65cc yz 2018/26": 54938273382741,
  "80cc pw 1983/06": 54938273415509,
  "50cc pw toutes annees": 54938273448277,
  "125cc dt-r/dt-x 1998/06": 54938273481045
};
var OPT_VAR  = 54938272268629;   /* brique « Options Selle CROSS » à 1 € */
var PACK_VAR = 54119771603285;   /* pack entretien, commun à toute la boutique */
/* @@VARIANTES_FIN@@ */

/* ---------- prix ----------
   paliers[n] où n = nombre de zones coupées en deux (0, 1 ou 2). Ces valeurs
   DOIVENT correspondre aux fiches mono-produit, sinon le client voit un prix
   dans le configurateur et un autre dans la gamme. */
var PRIX = {
  paliers: [69.00, 89.00, 120.00],
  num:     20.00,
  pack:    17.82
};
var PALIER_NOM = ['Trois pièces', 'Quatre pièces', 'Cinq pièces'];

/* ---------- position du numéro ----------
   Le numéro va sur le dessus AVANT, la partie qui se voit quand on regarde la
   moto de trois quarts ; l'arrière porte le patch BKS.

   Côtes RELEVÉES PAR LE PATRON le 12/09/2026 avec « POSITIONNER LE NUMERO
   CROSS.html », et elles ne sont pas celles que j'avais calculées : il a mis le
   numéro tout à l'avant, sur le nez de la selle, petit (2 % de la largeur) et
   incliné de -19°. Mon repère mesuré — centre de matière à 37,9/25,5, axe de la
   bande à 57° — plaçait un gros numéro au milieu du dessus. C'est son œil qui
   tranche, pas la géométrie.

   « max » = largeur maximale tolérée en % de l'aperçu ; au-delà le texte
   rétrécit au lieu de déborder. À cette taille trois chiffres font 3,6 % :
   8 ne bride rien et sert de garde-fou si la taille change un jour. */
var NUM = { left:32.3, top:13.4, taille:2.0, rot:-19, max:8, lim:3 };

/* Couleurs de fil, la palette de la FUSION à l'identique : ce sont les bobines
   que l'atelier a en stock, inutile d'en proposer d'autres. */
var FIL = [
  ['Noir','#1a1a1a'], ['Blanc','#f2f2f2'], ['Gris','#9a9a9a'], ['Rouge','#d11a2a'],
  ['Orange','#e8791a'], ['Jaune','#e0c81a'], ['Vert','#4caf24'], ['Turquoise','#1ac0c0'],
  ['Bleu clair','#3aa6d8'], ['Bleu','#2740c9'], ['Rose','#d02ab0'], ['Violet','#8a2be2'],
  ['Or','#c8a020']
];
function nomFil(h){ for(var i=0;i<FIL.length;i++) if(FIL[i][1] === h) return FIL[i][0]; return h; }
function filValide(h){ return nomFil(h) === h ? FIL[1][1] : h; }   /* inconnu -> blanc */

/* Où tombe chaque bande. Relevé sur les calques : grip1 est la plus proche de
   l'avant, grip5 la plus arrière. L'atelier lit ces mots sur la commande. */
var POSE = ['avant', 'avant-milieu', 'milieu', 'milieu-arrière', 'arrière'];

/* ---------- état ----------
   Départ : selle noire, flanc orange, bandes orange. C'est la « Noire et
   orange » du catalogue, la plus vendue chez le concurrent — le client arrive
   sur quelque chose de vendable, pas sur une selle vide. */
var C = {
  marque:  '',
  modele:  '',
  dessus:  { mode:'un',  un:'noir',   haut:'noir',   bas:'noir' },
  coter:   { mode:'un',  un:'orange', haut:'orange', bas:'noir' },
  bandes:  { mode:'uni', s:['orange','orange','orange','orange','orange'] },
  num:     { t:'', c:'#f2f2f2' },
  pack:    false,
  touched: { moto:false, dessus:false, coter:false, bandes:false, num:false }
};

var STEPS = [
  { ic:'🏍️', lb:'Ta moto' }, { ic:'🎨', lb:'Dessus' }, { ic:'🔻', lb:'Côtés' },
  { ic:'〰️', lb:'Bandes' },  { ic:'🔢', lb:'Numéro' }, { ic:'🧾', lb:'Récap' }
];
var cur = 0;

/* ---------- outils ---------- */
function $(i){ return document.getElementById(i); }
function eur(n){ return n.toFixed(2).replace('.', ',') + ' €'; }
function touch(k){ C.touched[k] = true; }
function mklabel(t){ var d = document.createElement('div'); d.className = 'lb'; d.textContent = t; return d; }

/* nuancier : les sept couleurs, la teinte réelle du calque en fond */
function nuancier(choisi, onpick){
  var w = document.createElement('div'); w.className = 'sws';
  COULEURS.forEach(function(o){
    var x = document.createElement('div'); x.className = 'swx';
    var b = document.createElement('div');
    b.className = 'sw' + (o.slug === choisi ? ' sel' : '');
    b.style.background = o.hex;
    b.title = o.nom;
    b.onclick = function(){ onpick(o.slug); };
    var l = document.createElement('div'); l.className = 'swlab'; l.textContent = o.nom;
    x.appendChild(b); x.appendChild(l); w.appendChild(x);
  });
  return w;
}

/* bascule « d'un tenant / en deux parties » */
function bascule(mode, aUn, aDeux, onpick){
  var t = document.createElement('div'); t.className = 'toggle';
  [['un', aUn], ['deux', aDeux]].forEach(function(p){
    var b = document.createElement('button');
    b.className = (mode === p[0] ? 'sel' : '');
    b.innerHTML = p[1];
    b.onclick = function(){ onpick(p[0]); };
    t.appendChild(b);
  });
  return t;
}

/* ---------- prix ---------- */
function coupes(){ return (C.dessus.mode === 'deux' ? 1 : 0) + (C.coter.mode === 'deux' ? 1 : 0); }
function base(){ return PRIX.paliers[coupes()]; }
function pNum(){ return C.num.t.trim() ? PRIX.num : 0; }
function pPack(){ return C.pack ? PRIX.pack : 0; }
function total(){ return base() + pNum() + pPack(); }
function variante(){ return VAR[C.modele] || 0; }
function bandeSlug(i){ return C.bandes.mode === 'uni' ? C.bandes.s[0] : C.bandes.s[i]; }
function etapeFaite(i){
  return [C.touched.moto && !!C.modele, C.touched.dessus, C.touched.coter,
          C.touched.bandes, C.touched.num, false][i];
}

/* ---------- aperçu ---------- */
function paint(){
  /* On ne remplace le calque qu'une fois la nouvelle image chargée, sinon
     l'ancienne disparaît le temps du téléchargement et la selle « saute ». */
  function set(id, zone, slug, montrer){
    var e = $(id);
    if(!montrer){ e.style.display = 'none'; return; }
    var u = urlCalque(zone, slug);
    if(e.getAttribute('src') === u){ e.style.display = ''; return; }
    var pre = new Image();
    pre.onload  = function(){ e.src = u; e.style.display = ''; };
    pre.onerror = function(){ e.style.display = 'none'; };
    pre.src = u;
  }
  var dUn = C.dessus.mode === 'un', cUn = C.coter.mode === 'un';
  set('L_dessus',      'dessus',      C.dessus.un,   dUn);
  set('L_dessus-haut', 'dessus-haut', C.dessus.haut, !dUn);
  set('L_dessus-bas',  'dessus-bas',  C.dessus.bas,  !dUn);
  set('L_coter',       'coter',       C.coter.un,    cUn);
  set('L_coter-haut',  'coter-haut',  C.coter.haut,  !cUn);
  set('L_coter-bas',   'coter-bas',   C.coter.bas,   !cUn);
  for(var i = 1; i <= 5; i++) set('L_grip' + i, 'grip' + i, bandeSlug(i-1), true);
  peindreNum();

  $('wm').textContent = C.marque ? marqueDe(C.marque).nom.toUpperCase() : 'CROSS';
  $('fly').textContent = PALIER_NOM[coupes()] + ' · ' + eur(base());
  var t = eur(total()), tv = $('tot');
  if(tv.textContent !== t){ tv.textContent = t; tv.classList.add('bump');
    setTimeout(function(){ tv.classList.remove('bump'); }, 200); }
  $('stp').textContent = 'Étape ' + (cur+1) + '/' + STEPS.length;
  $('bn').textContent  = (cur === STEPS.length-1) ? '🛒 Ajouter au panier' : 'Suivant →';

  var pl = $('pills'); pl.innerHTML = '';
  STEPS.forEach(function(s, i){
    var b = document.createElement('button');
    b.className = 'pill' + (i === cur ? ' act' : '') + (etapeFaite(i) ? ' done' : '');
    b.innerHTML = s.ic + ' ' + s.lb;
    b.onclick = function(){ cur = i; render(); };
    pl.appendChild(b);
  });
  centrerPastille();
}

/* recentre la pastille active sans faire bouger la page verticalement */
function centrerPastille(){
  var pl = $('pills'), act = pl && pl.children[cur];
  if(!act) return;
  var maxi = pl.scrollWidth - pl.clientWidth;
  pl.classList.toggle('defile', maxi > 0);
  if(maxi > 0){
    var rb = pl.getBoundingClientRect(), ra = act.getBoundingClientRect();
    pl.scrollLeft = Math.max(0, Math.min(maxi,
      pl.scrollLeft + (ra.left - rb.left) - (pl.clientWidth - ra.width) / 2));
  } else pl.scrollLeft = 0;
}

/* ---------- le numéro brodé ----------
   Il rétrécit tout seul pour tenir dans la largeur du dessus, comme une vraie
   broderie : trois chiffres larges ne doivent pas déborder sur le flanc. */
function peindreNum(){
  var el = $('B_num'), t = (C.num.t || '').trim();
  if(!t){ el.style.display = 'none'; return; }
  el.textContent = t.slice(0, NUM.lim);
  el.setAttribute('style', 'display:block;left:' + NUM.left + '%;top:' + NUM.top + '%;'
    + 'transform:translate(-50%,-50%) rotate(' + NUM.rot + 'deg);'
    + 'color:' + C.num.c + ';text-shadow:0 1px 2px rgba(0,0,0,.55);');
  var L = $('stage').clientWidth || 520;
  el.style.fontSize = (NUM.taille / 100 * L) + 'px';
  var w = el.scrollWidth, maxPx = NUM.max / 100 * L;
  if(w > maxPx) el.style.fontSize = ((NUM.taille * maxPx / w) / 100 * L) + 'px';
}
window.addEventListener('resize', function(){ peindreNum(); centrerPastille(); });
if(document.fonts && document.fonts.ready) document.fonts.ready.then(peindreNum);

/* ---------- l'encart pack entretien ---------- */
function upsell(){
  var d = document.createElement('div'); d.className = 'upsell';
  d.innerHTML = '<span class="ubadge">+ malin</span>'
    + '<div class="ubody"><div class="utitle">Pack entretien simili</div>'
    + '<div class="udesc">Nettoyant + protecteur. La terre part, la couleur reste.</div>'
    + '<div><span class="uold">26,90 €</span><span class="unew">' + eur(PRIX.pack) + '</span></div></div>';
  var b = document.createElement('button');
  b.className = 'ubtn' + (C.pack ? ' added' : '');
  b.textContent = C.pack ? '✓ Ajouté' : 'Ajouter';
  b.onclick = function(){ C.pack = !C.pack; render(); };
  d.appendChild(b);
  return d;
}

/* ---------- les étapes ---------- */
function render(){
  var p = $('pane'); p.innerHTML = '';

  if(cur === 0){
    p.innerHTML = '<h2>Ta moto 🏍️</h2><div class="sub">La housse est coupée au patron '
      + 'de ton modèle : elle se pose sur ta mousse d’origine.</div>';
    p.appendChild(mklabel('Marque'));
    var mm = document.createElement('div'); mm.className = 'mats';
    MARQUES.forEach(function(m){
      var b = document.createElement('button');
      b.className = 'mat' + (C.marque === m.cle ? ' sel' : '');
      b.innerHTML = m.nom + '<span class="mp">' + m.modeles.length + ' gabarits</span>';
      b.onclick = function(){
        C.marque = m.cle;
        if(m.modeles.indexOf(C.modele) < 0) C.modele = '';
        touch('moto'); render();
      };
      mm.appendChild(b);
    });
    p.appendChild(mm);

    if(C.marque){
      p.appendChild(mklabel('Modèle'));
      var s = document.createElement('select');
      var o0 = document.createElement('option');
      o0.value = ''; o0.textContent = '— choisis ton modèle —';
      s.appendChild(o0);
      marqueDe(C.marque).modeles.forEach(function(m){
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        if(m === C.modele) o.selected = true;
        s.appendChild(o);
      });
      s.onchange = function(){ C.modele = this.value; touch('moto'); paint(); };
      p.appendChild(s);
      var n = document.createElement('div'); n.className = 'note';
      n.innerHTML = 'Ton modèle n’est pas dans la liste ? Écris-nous : on découpe '
        + 'régulièrement de nouveaux patrons, et le tien est peut-être déjà en cours.';
      p.appendChild(n);
    }
  }

  else if(cur === 1){
    p.innerHTML = '<h2>Le dessus 🎨</h2><div class="sub">La grande surface, celle qu’on voit '
      + 'de loin. C’est ici que se décide le prix : un dessus coupé en deux, c’est une '
      + 'couture de plus en travers de la selle.</div>';
    p.appendChild(bascule(C.dessus.mode,
      'D’un tenant<span class="mp">inclus</span>',
      'En deux parties<span class="mp">+' + Math.round(PRIX.paliers[1] - PRIX.paliers[0]) + ' €</span>',
      function(m){ C.dessus.mode = m; touch('dessus'); render(); }));

    if(C.dessus.mode === 'un'){
      p.appendChild(mklabel('Couleur du dessus'));
      p.appendChild(nuancier(C.dessus.un, function(s){ C.dessus.un = s; touch('dessus'); render(); }));
    } else {
      p.appendChild(mklabel('Partie avant'));
      p.appendChild(nuancier(C.dessus.haut, function(s){ C.dessus.haut = s; touch('dessus'); render(); }));
      p.appendChild(mklabel('Partie arrière'));
      p.appendChild(nuancier(C.dessus.bas, function(s){ C.dessus.bas = s; touch('dessus'); render(); }));
    }
    var b = document.createElement('div'); b.className = 'note';
    b.innerHTML = '🅱️ Le <b>patch BKS</b> est cousu à l’arrière du dessus. Il reste noir, '
      + 'quelle que soit la couleur choisie.';
    p.appendChild(b);
  }

  else if(cur === 2){
    p.innerHTML = '<h2>Les côtés 🔻</h2><div class="sub">Les flancs, ce qu’on voit debout à '
      + 'côté de la moto. Coupés en deux, ils donnent la ligne la plus travaillée de la '
      + 'gamme.</div>';
    p.appendChild(bascule(C.coter.mode,
      'D’un tenant<span class="mp">inclus</span>',
      'En deux parties<span class="mp">+' + Math.round(PRIX.paliers[1] - PRIX.paliers[0]) + ' €</span>',
      function(m){ C.coter.mode = m; touch('coter'); render(); }));

    if(C.coter.mode === 'un'){
      p.appendChild(mklabel('Couleur des côtés'));
      p.appendChild(nuancier(C.coter.un, function(s){ C.coter.un = s; touch('coter'); render(); }));
    } else {
      p.appendChild(mklabel('Haut du flanc'));
      p.appendChild(nuancier(C.coter.haut, function(s){ C.coter.haut = s; touch('coter'); render(); }));
      p.appendChild(mklabel('Bas du flanc'));
      p.appendChild(nuancier(C.coter.bas, function(s){ C.coter.bas = s; touch('coter'); render(); }));
    }
    if(coupes() === 2){
      var n = document.createElement('div'); n.className = 'note';
      n.innerHTML = 'Dessus <b>et</b> côtés coupés : c’est la selle à <b>'
        + eur(PRIX.paliers[2]) + '</b>, cinq pièces de simili assemblées à la main.';
      p.appendChild(n);
    }
  }

  else if(cur === 3){
    p.innerHTML = '<h2>Les bandes 〰️</h2><div class="sub">Cinq bandes grip, de l’avant vers '
      + 'l’arrière. Les colorer une par une ne coûte rien de plus — c’est de la couleur, '
      + 'pas de la découpe.</div>';
    p.appendChild(bascule(C.bandes.mode,
      'Toutes pareilles', 'Bande par bande<span class="mp">gratuit</span>',
      function(m){ C.bandes.mode = m; touch('bandes'); render(); }));

    if(C.bandes.mode === 'uni'){
      p.appendChild(mklabel('Couleur des cinq bandes'));
      p.appendChild(nuancier(C.bandes.s[0], function(s){
        C.bandes.s = [s,s,s,s,s]; touch('bandes'); render(); }));
    } else {
      for(var i = 0; i < 5; i++) (function(i){
        var card = document.createElement('div'); card.className = 'bandcard';
        var t = document.createElement('div'); t.className = 'bt';
        t.textContent = 'Bande ' + (i+1) + ' (' + POSE[i] + ')';
        card.appendChild(t);
        card.appendChild(nuancier(C.bandes.s[i], function(s){
          C.bandes.s[i] = s; touch('bandes'); render(); }));
        p.appendChild(card);
      })(i);
    }
  }

  else if(cur === 4){
    p.innerHTML = '<h2>Ton numéro 🔢</h2><div class="sub">Brodé sur l’avant du dessus, '
      + 'à l’endroit où il se voit quand la moto est de trois quarts. Facultatif.</div>';
    var box = document.createElement('div'); box.className = 'brodbox';
    box.innerHTML = '<div class="bt"><span>Numéro de course</span><span class="bp">+'
      + eur(PRIX.num) + '</span></div>';
    var inp = document.createElement('input');
    inp.type = 'text'; inp.maxLength = NUM.lim; inp.value = C.num.t;
    inp.placeholder = 'Ex. 47 — jusqu’à ' + NUM.lim + ' chiffres';
    inp.oninput = function(){
      var v = this.value.replace(/[^0-9A-Za-z]/g, '').slice(0, NUM.lim);
      if(this.value !== v) this.value = v;
      var avant = !!C.num.t.trim();
      C.num.t = v; touch('num'); paint();
      /* la couleur de fil n'apparaît qu'une fois le numéro saisi : on ne
         redessine l'étape qu'au moment où ce bloc doit apparaître ou partir,
         sinon le champ perdrait le focus à chaque frappe */
      if(avant !== !!v){ var pos = v.length; render();
        var n2 = document.querySelector('.brodbox input');
        if(n2){ n2.focus(); try{ n2.setSelectionRange(pos, pos); }catch(e){} } }
    };
    box.appendChild(inp);
    p.appendChild(box);

    if(C.num.t.trim()){
      p.appendChild(mklabel('Couleur du fil'));
      var w = document.createElement('div'); w.className = 'sws';
      FIL.forEach(function(f){
        var x = document.createElement('div'); x.className = 'swx';
        var b2 = document.createElement('div');
        b2.className = 'sw mini' + (f[1] === C.num.c ? ' sel' : '');
        b2.style.background = f[1]; b2.title = f[0];
        b2.onclick = function(){ C.num.c = f[1]; touch('num'); render(); };
        var l = document.createElement('div'); l.className = 'swlab'; l.textContent = f[0];
        x.appendChild(b2); x.appendChild(l); w.appendChild(x);
      });
      p.appendChild(w);
    }
    var n3 = document.createElement('div'); n3.className = 'note';
    n3.innerHTML = 'Pas de pseudo ni de logo pour l’instant sur la gamme cross : '
      + 'la selle frotte trop sous le genou pour qu’une grande broderie tienne. '
      + 'Le numéro, lui, est placé là où ça ne frotte pas.';
    p.appendChild(n3);
    p.appendChild(upsell());
  }

  else {
    p.innerHTML = '<h2>Ta selle 🧾</h2><div class="sub">Vérifie avant d’ajouter au panier.</div>';
    var r = document.createElement('div'); r.className = 'recap';
    lignes().forEach(function(l){
      var d = document.createElement('div'); d.className = 'rr';
      d.innerHTML = '<span>' + l[0] + '</span><b>' + l[1] + '</b>';
      r.appendChild(d);
    });
    var tt = document.createElement('div'); tt.className = 'rr';
    tt.innerHTML = '<span><b>Total</b></span><b>' + eur(total()) + '</b>';
    r.appendChild(tt);
    p.appendChild(r);
    var tr = document.createElement('div'); tr.className = 'trust';
    tr.innerHTML = '<span>✂️ Coupée au patron de ta moto</span><span>🧵 Cousue main en France</span>'
      + '<span>📦 Tu gardes ta mousse</span>';
    p.appendChild(tr);
    p.appendChild(upsell());
  }

  paint();
}

/* ---------- récap et commande ---------- */
function zoneTxt(z, hautLab, basLab){
  return z.mode === 'un' ? nomCoul(z.un)
       : hautLab + ' ' + nomCoul(z.haut) + ' · ' + basLab + ' ' + nomCoul(z.bas);
}
function lignes(){
  var L = [];
  L.push(['Moto', C.modele || '—']);
  L.push(['Découpe', PALIER_NOM[coupes()] + ' — ' + eur(base())]);
  L.push(['Dessus', zoneTxt(C.dessus, 'avant', 'arrière')]);
  L.push(['Côtés',  zoneTxt(C.coter,  'haut',  'bas')]);
  L.push(['Bandes', C.bandes.mode === 'uni'
    ? nomCoul(C.bandes.s[0]) + ' (les cinq)'
    : C.bandes.s.map(function(s, i){ return POSE[i] + ' : ' + nomCoul(s); }).join(' · ')]);
  L.push(['Patch BKS', 'Noir']);
  if(C.num.t.trim()) L.push(['Numéro brodé', C.num.t.trim() + ' — fil ' + nomFil(C.num.c)]);
  if(C.pack) L.push(['Pack entretien', eur(PRIX.pack)]);
  return L;
}

function manque(){
  if(!C.modele) return { step:0, msg:'Choisis ta moto 🏍️' };
  return null;
}

/* Même mécanique que la VELTO : la selle au palier de base, puis la brique
   « Options » à 1 € en quantité = nombre d'euros de supplément. Les lignes sont
   reliées par _bks_id ; bks-cart-guard.js les fait vivre et mourir ensemble. */
function props(id){
  var p = {};
  lignes().forEach(function(l){ p[l[0]] = l[1]; });
  delete p['Pack entretien'];
  p['_bks_id'] = id;
  p['_bks_role'] = 'base';
  return p;
}
function addToCart(){
  var m = manque();
  if(m){ cur = m.step; render(); window.scrollTo({ top:0, behavior:'smooth' }); alert(m.msg); return; }
  var v = variante();
  if(!v){ cur = 0; render();
    alert('Ce gabarit n’est pas encore relié à la fiche. Préviens-nous, on le pose tout de suite.');
    return; }

  /* la brique couvre TOUT ce qui dépasse le palier de base à 69 €, découpe
     comprise : une variante par gabarit suffit, pas une par palier */
  var supp = Math.round(total() - PRIX.paliers[0] - pPack());
  if(supp > 0 && !OPT_VAR){
    alert('La brique de prix des options n’est pas configurée. Préviens-nous.'); return;
  }
  var id = 'CRX-' + Date.now();
  var items = [{ id:v, quantity:1, properties:props(id) }];
  if(supp > 0) items.push({ id:OPT_VAR, quantity:supp, properties:{
    '_bks_id':id, '_bks_role':'brick', 'Détail':'Découpe & options (+' + supp + ' €)' } });
  if(C.pack) items.push({ id:PACK_VAR, quantity:1, properties:{
    '_bks_id':id, '_bks_role':'supp', 'Détail':'Pack entretien' } });
  items[0].properties['_bks_parts']    = String(items.length);
  items[0].properties['_bks_brickqty'] = String(supp > 0 ? supp : 0);

  var btn = $('bn'); btn.disabled = true; btn.textContent = 'Ajout…';
  fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' },
                          body: JSON.stringify({ items:items }) })
    .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw new Error(t); });
                       window.location.href = '/cart'; })
    .catch(function(){ btn.disabled = false; btn.textContent = '🛒 Ajouter au panier';
                       alert('L’ajout au panier a échoué. Réessaie, et préviens-nous si ça persiste.'); });
}

/* ---------- navigation ---------- */
$('bp').onclick = function(){ if(cur > 0){ cur--; render(); window.scrollTo({ top:0, behavior:'smooth' }); } };
$('bn').onclick = function(){
  if(cur < STEPS.length-1){ cur++; render(); window.scrollTo({ top:0, behavior:'smooth' }); return; }
  addToCart();
};

/* ---------- démarrage ---------- */
C.num.c = filValide(C.num.c);
var g = litGamme();
if(g){
  C.marque = g; touch('moto');
  /* une seule moto dans la rubrique : rien à choisir, on la pose d'office */
  var mg = marqueDe(g);
  if(mg && mg.modeles.length === 1) C.modele = mg.modeles[0];
}
render();
})();
